{
  "billing": {
    "title": "Facturation",
    "page_title": "Facturation et forfaits",
    "page_content": "Vous pouvez modifier et gérer votre plan d'abonnement et modifier vos informations de paiement.",
    "in_arrears_error": {
      "title": "Mode de paiement manquant ou non valide",
      "content": "Votre compte est actuellement suspendu. Veuillez mettre à jour vos informations de paiement pour activer votre compte"
    },
    "cancelled_error_payed": {
      "title": "L'abonnement en cours est annulé",
      "content_1": "Votre compte a été annulé. Veuillez",
      "content_2": "nous contacter",
      "content_3": "pour réactiver votre compte"
    },
    "cancelled_error_trial": {
      "title": "Votre période d'essai est terminée",
      "content": "Votre compte a été annulé. Veuillez passer à un forfait payant pour continuer à utiliser Iventis."
    },
    "subscription_box": {
      "title": "Abonnement",
      "current_plan": "Plan actuel",
      "next_payment": "Prochain paiement",
      "renews_on": "Renouvelle le",
      "paid": "Payé",
      "days": "pour y aller",
      "get_in_touch": "Contactez-nous pour discuter de votre plan",
      "Trial": "Procès",
      "Active": "Actif",
      "Cancelled": "Annulé",
      "InArrears": "En retard"
    },
    "change_plan": "Changer de plan",
    "payment_details_box": {
      "title": "Détails du paiement",
      "payment_method": "Mode de paiement",
      "card_ending": "Carte se terminant par",
      "expires": "Expire",
      "billing_address": "Adresse de facturation",
      "no_payment_method": "Aucun mode de paiement",
      "payment_breakdown_project": "{{ amount }} (1 projet x {{ amount }}",
      "payment_breakdown_users": "{{ totalAmount }} {{ maxUsers }} utilisateurs x {{ userAmount }}",
      "payment_breakdown_user": "{{ totalAmount }} (1 utilisateur x {{ totalAmount }}",
      "users": "utilisateurs",
      "user": "utilisateur",
      "discount": "remise"
    },
    "redirect_modal": {
      "title": "Modifier le mode de paiement",
      "content": "Vous serez redirigé vers notre fournisseur de services de facturation pour modifier vos informations de paiement."
    },
    "excludes_taxes": "Toutes les taxes applicables sont exclues"
  },
  "upgrade_plan_warnings": {
    "upgrade_plan": "Plan de mise à niveau",
    "contact_us": "Nous contacter",
    "view_plans": "Afficher les plans"
  },
  "view_plans": "Afficher les plans",
  "subscription_details": {
    "title": "Détails de l'abonnement",
    "selected_plan": "Plan sélectionné",
    "plan_type": "Type de plan",
    "currency": "Devise",
    "billed": "Facturé",
    "payment_date": "Date de paiement",
    "payment_date_desc": {
      "Monthly": "{{ date }} de chaque mois",
      "Annually": "{{ date }}"
    },
    "renewal_date": "Date de renouvellement",
    "add_users": "Ajouter des utilisateurs",
    "add_payment_method": "Ajouter un mode de paiement",
    "cannot_switch_from_annual": "Veuillez nous contacter si vous souhaitez passer d'une facturation annuelle à une facturation mensuelle",
    "exceeded_max_users_message": "Veuillez nous contacter pour discuter de vos besoins si vous avez besoin de plus de {{ numberOfUsers }} utilisateurs",
    "continue_to_payment": "Poursuivre le paiement",
    "redirect_modal": {
      "title": "Modifier l'abonnement",
      "message": "En cliquant sur Continuer, vous serez redirigé vers notre fournisseur de services de facturation pour effectuer les paiements requis pour l'abonnement mis à jour"
    },
    "update_successful": "Abonnement mis à jour avec succès"
  },
  "subscription_price_breakdown": {
    "title": "Répartition des prix",
    "subscription_fee": "Frais d'abonnement",
    "individual_price_breakdown": "Répartition individuelle des prix",
    "discount_applied": "Réduction appliquée",
    "discount_has_been_applied": "Une réduction {{ discount }} a été appliquée automatiquement à votre compte",
    "total": "Total",
    "frequency_proice_breakdown": "Répartition des prix {{ frequency }}",
    "frequency": {
      "Monthly": "Mensuel",
      "Annually": "Annuellement"
    },
    "time_unit": {
      "Monthly": "mois",
      "Annually": "année"
    },
    "users": "utilisateurs",
    "excludes_taxes": "Exclut toutes les taxes applicables qui seront ajoutées sur la page de paiement"
  },
  "subscription_payment_breakdown": {
    "title": "Répartition des paiements",
    "vat": "TVA {{ percentage }} sur {{ total }}",
    "total_excluding_tax": "Total hors taxes",
    "amount_due": "Montant dû",
    "description": "Descriptif",
    "total": "Total",
    "unit": "Unité",
    "pay": "Payez {{ amount }}"
  },
  "order_summary": "Résumé de la commande",
  "settings": "Réglages"
}